let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8Kr9p")).then(() => parcelRequire('8mcrK'));